export const iw_salt_alarm_map = {
  1: { value: 'Lack of flow (salt)', levelMessage: 'danger', level: 3 },
  2: { value: 'Inhibit waiting', levelMessage: 'running', level: 1 },
  3: { value: 'Delay after calibration', levelMessage: 'running', level: 1 },
  4: { value: 'OFA alarm', levelMessage: 'problem', level: 3 },
  5: { value: 'Salinity low', levelMessage: 'running', level: 2 },
  6: { value: 'Mainteinance needed', levelMessage: 'warning', level: 2 },
  7: { value: 'Ice risk', levelMessage: 'warning', level: 2 },
  8: { value: 'Boost launched', levelMessage: 'warning', level: 2 },
  9: { value: 'Under-dosing alarm (salt)', levelMessage: 'warning', level: 2 },
  10: { value: 'Over-dosing alarm (salt)', levelMessage: 'warning', level: 2 },
  11: { value: 'Measure below minimum range', levelMessage: 'warning', level: 2 },
  12: { value: 'Measure above minimum range', levelMessage: 'warning', level: 2 },
  13: { value: 'Out of programmed time slot', levelMessage: 'running', level: 1 },
  14: { value: 'Standby', levelMessage: 'running', level: 1 },
  15: { value: 'Measure communication is not responding', levelMessage: 'problem', level: 3 },
  16: { value: 'FW update in progress', levelMessage: 'running', level: 2 },
  17: { value: 'Waiting for pH priority fulfillment', levelMessage: 'warning', level: 2 },
  18: { value: 'Safety pressure switcher trigger', levelMessage: 'problem', level: 3 },
  19: { value: 'Flow sensor not enabled', levelMessage: 'warning', level: 2 },
};

export const iw_salt_add_pump_alarm_map = {
  1: { value: 'Lack of flow (salt)', levelMessage: 'problem', level: 3 },
  2: { value: 'Inhibit waiting', levelMessage: 'running', level: 1 },
  3: { value: 'Delay after calibration', levelMessage: 'running', level: 1 },
  4: { value: 'OFA alarm', levelMessage: 'problem', level: 3 },
  5: { value: 'Chemical is finished', levelMessage: 'problem', level: 3 },
  7: { value: 'Measure below minimum range', levelMessage: 'warning', level: 2 },
  8: { value: 'Measure above minimum range', levelMessage: 'warning', level: 2 },
  9: { value: 'Out of programmed time slot', levelMessage: 'running', level: 1 },
  10: { value: 'Standby', levelMessage: 'running', level: 1 },
  11: { value: 'Measure communication is not responding', levelMessage: 'problem', level: 3 },
};
